import { useSelector } from 'react-redux';

import {
  selectActingProfileOrganization,
  selectProfileOrganization,
} from '~/store/profile/profileSlice.selectors';

/**
 * Organization the signed-in user is currently acting as, when that
 * differs from their own. Returns `undefined` when acting as oneself.
 *
 * Only a view-as session names an organization for a downstream
 * service. Acting as oneself leaves the acting profile equal to the
 * profile, and the Sidekick auth proxy already reads that organization
 * off the token, so sending it would restate what the request carries.
 *
 * Both Sidekick surfaces read this: the app-wide dock under the M1
 * flag, and the Insights route shell when M1 is off. A second copy of
 * the comparison would let the two disagree about what a view-as
 * session is.
 */
const useActingOrganizationId = (): string | undefined => {
  const organizationsId = useSelector(selectActingProfileOrganization)?.id;
  const homeOrganizationsId = useSelector(selectProfileOrganization)?.id;

  return organizationsId !== undefined &&
    organizationsId !== homeOrganizationsId
    ? organizationsId
    : undefined;
};

export default useActingOrganizationId;
